let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b9iN1")).then(() => parcelRequire('jdENA'));